export default __webpack_public_path__ + "static/media/2_0142.19ef2893.webp";